import React, { useState } from "react";
import { Layout } from "antd";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import ProfileMenu from "./ProfileMenu";

const { Content } = Layout;

interface PrivateLayoutProps { }

const PrivateLayout: React.FC<PrivateLayoutProps> = () => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <Layout className="site-layout h-screen overflow-hidden">
      <Layout.Sider
        breakpoint="lg"
        collapsedWidth="80"
        onCollapse={(collapsed) => {
          setCollapsed(collapsed);
        }}
        collapsed={collapsed}
        width={250}
        trigger={null}
        className="site-sidebar"
      >
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      </Layout.Sider>
      <Layout className="flex flex-col h-screen overflow-hidden">
        <Header collapsed={collapsed} setCollapsed={setCollapsed}>
          <ProfileMenu />
        </Header>
        <Content className="site-content bg-gradient-to-br from-gray-200 to-blue-200">
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default PrivateLayout;
